<template>
    <section class="course-admin">
        <div v-if="course">
            <div class="panel col-xs-12 col-md-12">
                <div class="panel-heading"> 
                    <h2>
                    {{course.name}}
                    <span class="core-curriculum" v-if="course.coreCurriculum">Core Curriculum</span>
                   </h2>

                </div>
                <div class="panel-body">

                <h5 v-if="$route.query.path_name && $route.query.term_name">
                    {{$route.query.path_name}} ({{$route.query.term_name}})
                </h5>
                <vue-html5-editor @change="updateCourseDescription" :content="courseDescription"></vue-html5-editor>
                <div class="core-curriculum-setting">
                    <label><input type="checkbox" v-model="course.coreCurriculum" />This course is part of the core curriculum, and should be included in attendance records</label>
                </div>
                <div class="core-curriculum-setting">
                    <input type="number" class="form-control" step="1" v-model="course.scheduledHours" /> Scheduled hours
                </div>
                <!-- <textarea class="form-control" v-model="course.description"></textarea> -->
                <button @click.prevent="updateCourse()" class="btn btn-xs btn-success">Save</button>
                <p>Set Your Course Image which will be displayed in various areas!<br />Pick something representative of your course!</p>
                <label for="course-image"><i class="fa fa-edit add-image"></i>
                    <input type="file" @change="setCourseImage()" ref="courseImage" class="course-image-file" id="course-image">
                    </label> 
                    <img class="course-image" v-if="course.image" :src="course.image">
                </div>
            </div>

        <div class="clearfix"></div>

        <div class="clearfix"></div>

        <lesson-cloner v-if="lessonToClone" :lesson="lessonToClone"></lesson-cloner>

        <div class="col-md-12  panel">
            <div class="panel-heading"><h2>Weekly Lessons</h2></div>
            <div class="panel-body">
                <table class="table table-striped table-bordered lessons-table">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>SKU</th>
                            <th>Week</th>
                            <th>Available</th>
                            <th>Colour</th>
                            <th>Instructor</th>
                            <td colspan="4">Edit</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(video, index) in videos">
                            <td>
                                <span v-if="editingVideo===false">{{video.title}}</span>
                                <input class="form-control" v-if="editingVideo===true" v-model="video.title">
                            </td>
                            <td>
                                <span v-if="editingVideo===false">{{video.sku}}</span>
                                <input class="form-control" v-if="editingVideo===true" v-model="video.sku">
                            </td>
                            <td>
                                <span v-if="editingVideo===false">{{video.week}}</span>
                                <select class="form-control" v-if="editingVideo===true" v-model="video.week">
                                    <option v-for="week in weeks">{{week}}</option>
                                </select>
                            </td>
                            <td>
                                <span v-if="editingVideo===false">{{video.weekAvailable}}</span>
                                <select class="form-control" v-if="editingVideo===true" v-model="video.weekAvailable">
                                    <option v-for="week in weeks">{{week}}</option>
                                </select>
                            </td>
                            <td :style="{'background': video.color}">
                                <span v-if="editingVideo===false"></span>
                                <input v-if="editingVideo===true" type="color" v-model="video.color">
                                <i v-if="editingVideo===true" class="fa fa-remove cursor-pointer" @click.prevent="video.color = null"></i>
                            </td>
                            <td>
                                <span v-if="editingVideo===false">{{video.instructorName}}</span>
                                <input v-if="editingVideo===true" type="text" class="form-control" v-model="video.instructorName">                               
                            </td>
                            <td class="text-center">
                                <button @click.prevent="deleteVideo(video.id, index, video.instanceId, video.week)" class="btn btn-xs btn-danger">Delete</button>
                            </td>
                            <td>
                                <button v-if="editingVideo===false" @click.prevent="editingVideo=true" class="btn btn-xs btn-warning">Edit</button>
                                <button v-if="editingVideo===true" @click.prevent="updateVideo(index)" class="btn btn-xs btn-success">Save</button>

                            </td>
                            <td>
                                <router-link  :to="{ name: 'videoChapters', 
                                params: { courseId: video.courseId, instanceId: instanceId, videoId: video.id },
                                query: {path: $route.query.path_name, term: $route.query.term_name, week: video.week}
                                }">
                                    <button class="btn btn-sm btn-warning">Videos</button>
                                </router-link> 
                            </td>
                            <td class="flex">   
                                <router-link v-if="video.exercise" :to="{ name: 'handins', params: { exerciseId: video.exercise.id }}">
                                    <button class="btn btn-sm btn-warning">Hand-Ins</button>
                                </router-link>      
                                <!-- <a v-if="flagged(video)" class="flag">!</a>   -->
                                <i @click="lessonToClone = video" class="fa fa-copy"></i>                    
                            </td>

                        </tr>
                    </tbody>
                </table>
                <form @submit.prevent="addVideo()">
                    <h4>Add Weekly Lesson</h4>
                    <div class="form-group">
                        <label>Title</label>
                        <input type="text" v-model="video.title" class="form-control" required>
                    </div>
                    <div class="form-group"> 
                        <label>Week</label>
                        <select v-model="video.week" class="form-control" @change="setWeekAvailable()" required>
                            <option v-for="week in weeks">{{week}}</option>
                        </select>
                    </div>
                    <div class="form-group"> 
                        <label>Week Available</label>
                        <select v-model="video.weekAvailable" class="form-control" required>
                            <option v-for="week in weeks">{{week}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>SKU</label>
                        <input type="text" v-model="video.sku" class="form-control" required>
                    </div>
                    <div class="form-group">
                        <label>Assign to</label>
                        <input type="text" v-model="video.instructorName" class="form-control" required>
                    </div>  
                    <div class="form-group">
                        <button class="btn btn-primary" type="submit">Add</button>
                    </div>
                </form>
                <form @submit.prevent="importVideo()" v-if="videosForImport">
                    <h4>
                        Import Lesson
                    </h4>
                    <div class="form-group">
                        <label>Week</label>
                        <select v-model="importedVideo.week" class="form-control">
                            <option v-for="week in weeks">{{week}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Video</label>
                        <select v-model="importedVideo.id" class="form-control">
                            <option v-for="video in videosForImport">
                                {{video.title}}
                            </option>
                        </select>
                    </div>
                  
                </form>
            </div>

        </div>

        </div>
    </section>
</template>


<script>


    import courses from '../services/courses';
    import aws from '../services/aws';
    import terms from '../services/terms';
    import videos from '../services/videos';
    import assignments from '../services/assignments';
    import files from '../services/files';
    import users from '../services/users';

    import discussions from './Discussion.vue';
    import Dropzone from 'vue2-dropzone';
    import datepicker from 'vue-datepicker';
    import moment from 'moment';
    import toastr from 'toastr';

    import LessonCloner from './widgets/LessonCloner';

    export default {
        data() {
            return {
                courseId: null,
                courseDescription: '',
                students: null,
                videos: [],
                videosForImport: null,
                importedVideo: {
                    week: null,
                    id: null
                },
                terms: null,
                video: {
                    title: '',
                    week: null,
                    sku: null
                },
                editingVideo: false,
                weeksWithResources: [],
                weeks: 16,
                newAssignment: {},
                isMultiWeek: false,
                dropzoneOptions: {
                    autoProcessQueue: false,
                    addRemoveLinks:true

                },
                assignmentFiles: [],
                assignmentImage: null,
                lessonToClone: null
            }
        },
        components: {
            discussions: discussions,
            'date-picker': datepicker,
            Dropzone,
            LessonCloner
        },
        mounted() {
            this.courseId = this.$route.params.courseId;   
            this.instanceId = this.$route.params.instanceId;             
          
            this.getCourse();
            this.getVideos();
            this.getTerms();

        },
        methods: {
            updateCourseDescription(content) {
                this.courseDescription = content;
            },        
            setWeekAvailable() {
                this.video.weekAvailable = this.video.week;
            },
            updateContent(content) {
                this.newAssignment.description = content;
            },
            updateVideo(index) {
                var self = this;
                const video = Object.assign({}, this.videos[index]);
                
                videos.updateVideo(this, video).then(function(response) {
                    if (response.data.success === true) {
                        toastr.success('Updated');
                        self.editingVideo = false;
                    } else {
                        toastr.error('Error updating');
                    }
                });
            },
            getVideosForImport() {
                var self = this;
                videos.getAll(this).then(function(response) {
                    self.videosForImport = response.data;
                    
                })
            },
            getTerms() {
                terms.get(this).then((response)=>{
                    console.log(response)
                    this.terms = response.data.terms;
                });
            },
            
            updateCourse() {
                const data = {
                    id: this.course.id,
                    description: this.courseDescription,
                    coreCurriculum: this.course.coreCurriculum,
                    scheduledHours: this.course.scheduledHours                
                }
                courses.update(data).then((response)=> {                    
                    response.data.success === true ? toastr.success('Updated successfully') : toastr.error('Error updating');
                });
            },

            setCourseImage() {
                var self = this;

                const uuidV4 = require('uuid/v4');
                const file = this.$refs.courseImage.files[0];
                const filename = uuidV4() + '.' + file.name.split('.').pop();

                aws.signature(file, filename, 'ttto-course-images').then(function(signature) {
                    aws.upload(file, filename, signature, 'ttto-course-images').then(function(response) {
                        courses.setImage(self, self.course.courseId, response.url).then(function(res) {
                            if (res.data.success === true) {
                                self.course.image = response.url;
                            }
                        });                                     
                    });
                });

            },


            getVideos() {
                var self = this;
                videos.get(self, self.courseId, self.instanceId).then(function(response) {
                    self.videos = response.data;
                    files.get(this, {}).then(function(response) {           
                        self.weeksWithResources = response.data.map(function(r) { if (r.courseId === self.courseId) return r.week });
                    });
                });
            },
            addVideo() {
                var self = this;
                self.video.courseId = self.courseId;
                self.video.instanceId = self.instanceId;
                videos.add(self, self.video).then(function(response) {
                    self.getVideos();
                });
            },
            // flagged(video) {
            //     if (!video.description) return true;
            //     if (!video.exercise && video.doesNotRequire.indexOf('exercise') === -1) return true;
            //     if (video.lesson_files.length < 1 && video.doesNotRequire.indexOf('files') === -1) return true;
                
            //     let assignmentData = this.$store.getters.singleCourse.assignments;
                
            //     let existing = assignmentData.findIndex(function(a) { return a['video.id'] == video.id});
            //     if (existing === -1 && video.doesNotRequire.indexOf('assignment') === -1) return true; 

            //     let hasResources = this.weeksWithResources.indexOf(video.week);
            //     if (hasResources === -1 && video.doesNotRequire.indexOf('resources') === -1) return true;                

            //     return false;
            // },
            deleteVideo(id, index, instanceId, week) {
                var self = this;

                this.$swal({
                  title: 'Are you sure?',
                  text: 'This will also delete all videos for the lesson, and any assignments and exercises submitted for them',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, delete it!',
                  cancelButtonText: 'No, keep it'
                }).then(function() {
                    videos.deleteVideo(self, id, instanceId, week).then(function(response){
                        if (response.data.success === true) {
                            self.$swal(
                                'Deleted!',
                                'Your lesson has been deleted.',
                                'success'
                              );
                            self.videos.splice(index,1);
                        } else {
                               
                               const message = response.data.message || 'Error deleting chapter.';
                               
                               self.$swal(
                                'Error',
                                message,
                                'error'
                              ); 
                        } 
                    })

                }, function(dismiss) {

                });
            },
            getCourse() {
                var self = this;

                courses.get(self, self.courseId, false).then(function(response) {
                    let course = response.data;         
                    if (course.description) { self.courseDescription = course.description; }
                    
                    assignments.get(self, self.courseId, self.instanceId, null).then(function(res) {
                        course.assignments = res.data;
                        self.$store.dispatch('populate', { type: 'singleCourse', data:course  });
                    });
                    
                });

    
            },

        },
        computed: {

            course() {
                if (this.$store.state.singleCourse) {
                    return this.$store.state.singleCourse;
                }
            },
        }
    }

</script>

<style lang="scss" scoped>

.core-curriculum {
    background: #5cb85c;
    color:#fff!important;
    font-weight:600;
    font-size:16px;
    border-radius: 4px;
    margin-left:1rem;
    padding:.25rem .75rem;
}
.course-image {
    max-width:200px;
}
.lessons-table td.flex {
     display:flex;
     align-items:center;
     justify-content: space-around;
}

.lessons-table i.fa-copy {
    cursor:pointer;
}

textarea {
    margin-bottom:2rem;
    min-height:150px;
    & + button {
        margin-bottom:2rem;
    }
}

.core-curriculum-setting {
    margin:1rem 0;
    label {
        font-weight:600;
        color:#fff;
    }
    input {
        margin-right:1rem;
    }
}
.flag {
    color:red;
    float:right;
    font-size:2rem;
}
.list-group-item {padding:0;}

.form-control:not([type="file"]) {
    background:rgba(0,0,0,.2)!important;
    }

.create-assignment-title {    
        margin-top:30px;    
}
    .course-image-file {
        display:none!important;
    }
    label[for="course-image"] {
        font-size:3rem;
        float:right;
    }
    .panel-body {
       padding:20px!important;    
    }

    .assignments {
        h2 img {
            margin-right:1rem;
        }
    }
</style>

<style lang="scss">


    .VueCarousel-navigation-button {
        z-index:99999;
        color:transparent!important;
        &::after {
            font-family: 'FontAwesome';
            color:#fff;
        }
    }
     .VueCarousel-navigation-next {
        &::after {
            content: "\f105";
            font-size:2rem;
        }
     }
     .VueCarousel-navigation-prev {
        &::after {
            content: "\f104";
            font-size:2rem;
        }
     }
</style>




// WEBPACK FOOTER //
// CourseAdmin.vue?1570689e